import { useQuery } from '@tanstack/react-query';

import {
  getDictionaryByType,
  getGetDictionaryByTypeQueryKey,
} from 'api/generated/dictionary-controller/dictionary-controller';
import type { DictionaryDto } from 'api/generated/schemas/dictionaryDto';

export type CategoryDictionaryType = Parameters<typeof getDictionaryByType>[1];

const dictionaryItemsToLabelMap = (
  items: DictionaryDto[]
): Record<string, string | undefined> => {
  const labels: Record<string, string | undefined> = {};

  items.forEach((item) => {
    const key = item.name;

    if (!key) {
      return;
    }

    labels[key] = item.description ?? item.name;
  });

  return labels;
};

interface UseCategoryDictionaryParams {
  userId: string;
  type: CategoryDictionaryType;
  enabled?: boolean;
}

export const useCategoryDictionary = ({
  userId,
  type,
  enabled = true,
}: UseCategoryDictionaryParams) =>
  useQuery({
    queryKey: getGetDictionaryByTypeQueryKey(userId, type),
    queryFn: ({ signal }) =>
      getDictionaryByType(userId, type, undefined, signal),
    enabled: enabled && !!userId && !!type,
    staleTime: Infinity,
    select: dictionaryItemsToLabelMap,
  });
